module.exports = __webpack_public_path__ + "img/sld_scb_3_green.3f55816f.svg";